import appStore from 'store'
import api from './api'
import { PAGINATION } from './constants'
import cookies from 'js-cookie'
import { Message } from 'element-ui'

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    showList: false,
    googleVisible: false,
    infoTotal: 0,
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list
      state.totalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setShowList(state, payload) {
      state.showList = payload
    },
    setGoogleVisible(state, payload) {
      state.googleVisible = payload
    },
    setInfoTotal(state, payload) {
      state.infoTotal = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          if (res.data == -2) {
            cookies.remove('send-token')
            Message({
              type: 'error',
              message: '请重新输入谷歌验证码',
            })
            commit('setShowList', false)
            return
          }
          commit('setUserList', res.data)
          commit('setShowList', true)
        }
      })
    },
    getTotalInfo({ commit }, query = {}) {
      // commit('setPagination', { page: query.page, size: query.size });
      api.getTotalInfo(query).then((res) => {
        if (res.code == 0) {
          commit('setInfoTotal', res.data)
        }
      })
    },
    getSendToken({ commit }, query = {}) {
      // commit('setPagination', { page: query.page, size: query.size });
      return api.getSendToken(query)
    },
  },
}

appStore.registerModule('giftCoin', store)
